export const SUPPLIER_ETL_FILENAME = 'suppliers.json';
export const SUPPLIER_AVATAR_ETL_FILENAME = 'supplierAvatars.json';
export const USER_ETL_FILENAME = 'users.json';